import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'ai-chat-session-rename-dialog',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './ai-chat-session-rename-dialog.component.html',
    styleUrls: ['./ai-chat-session-rename-dialog.component.scss'],
})
export class AiChatSessionRenameDialogComponent implements OnInit, OnChanges {
    public static readonly MAX_TITLE_LENGTH = 80;

    @Input() public titleValue = '';

    public draftTitle = '';

    public readonly maxTitleLength = AiChatSessionRenameDialogComponent.MAX_TITLE_LENGTH;

    public ngOnInit(): void {
        this.draftTitle = this.clampTitle(this.titleValue);
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['titleValue']) {
            this.draftTitle = this.clampTitle(this.titleValue);
        }
    }

    public get trimmedTitle(): string {
        return this.clampTitle(this.draftTitle.trim());
    }

    private clampTitle(value: string | null | undefined): string {
        return (value ?? '').slice(0, this.maxTitleLength);
    }
}
